import { kebabCase } from 'lodash';
import * as React from 'react';

interface ProfileMenuProps {
  history: any
}

class ProfileMenu extends React.Component<ProfileMenuProps> {
  /**
   * Map of side bar menu items
   */
  private menuMap = {
    Personal: [
      { name: "Personal Info", icon: "fas fa-user-circle" },
      { name: "Job Histories", icon: "fas fa-briefcase" },
      { name: "Educations", icon: "fas fa-graduation-cap" },
      { name: "Self Evaluation", icon: "fas fa-chalkboard" }
    ]
  };

  public render() {
    return (
      <aside className="menu">
        {this.renderMenuItems()}
      </aside>
    );
  }

  private renderMenuItems = () => {
    return Object.entries(this.menuMap).map(([ label, menuItems ]) =>
      <div key={label}>
        <p className="menu-label">{label}</p>
        <ul className="menu-list">
          {menuItems.map(item => (
            <li className="profile-menu-item" key={item.name}>
              <a data-scroll-target={`${kebabCase(item.name)}`} href={`#${kebabCase(item.name)}`} onClick={this.handleMenuClick}>
                <span className="icon is-medium"><i className={item.icon}/></span>
                {item.name}
              </a>
            </li>
          ))}
        </ul>
      </div>
    );
  }

  /**
   * Scroll smoothly to the component.
   */
  private handleMenuClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    const selectedMenu = event.currentTarget;
    const query = '.profile-menu-item > a.is-active';
    const activeAnchors: HTMLAnchorElement[]= Array.from(document.querySelectorAll(query));
    
    const { value } = selectedMenu.attributes.getNamedItem('data-scroll-target')!;

    // Pushing this to browser history manually because we prevented default.
    this.props.history.push(`#${value}`);
    
    // Remove `is-active` class name from all the other links
    activeAnchors.forEach(anchor => anchor.classList.remove('is-active'));
    selectedMenu.classList.add('is-active');
    
    const targetElement = document.querySelector(`#${value}`);
    if (targetElement) {
      targetElement.scrollIntoView({ block: 'start', behavior: 'smooth', inline: 'nearest' });
    }
  }
}

export default ProfileMenu;


// WEBPACK FOOTER //
// ./src/pages/profile/ProfileMenu.tsx